<div class="app-accept-invite-code container-fluid">
    <cf-loader class="loader"></cf-loader>
</div>